import { MathUtils } from "three/src/math/MathUtils";
import { Vector3 } from "three/src/math/Vector3";

export const getProjFactor = (fov, distance, screenHeight) => {
  let projFactor = 1.0 / Math.tan(fov / 2);
  projFactor /= distance;
  projFactor *= screenHeight / 2;
  return projFactor;
};

export const setPointScale = (viewer, mesh, buffer = 1.0) => {
  if (!mesh) {
    return;
  }

  const fov = MathUtils.degToRad(Math.max(60, viewer.camera.fov));
  const screenHeight = viewer.height;

  const distance = Math.max(1.0, mesh.position.distanceTo(viewer.camera.position));
  const projFactor = getProjFactor(fov, distance, screenHeight);
  const scale = 50 / projFactor;

  mesh.scale.set(scale, scale, scale);
  mesh.geometry.computeBoundingSphere();
  mesh.geometry.boundingSphere.radius *= buffer;
};

export const toScreenPosition = (viewer, position) => {
  var vector = new Vector3();
  vector.set(position.x, position.y, position.z);
  vector.project(viewer.camera);

  vector.x = Math.round((vector.x + 1) * viewer.width / 2);
  vector.y = Math.round((-vector.y + 1) * viewer.height / 2);
  vector.z = 0;

  return vector;
};

export const eventToPixel = (event) => {
  let uv = new Vector3();
  if (event.offsetX) {
    // chrome,ie,safari
    uv.x = event.offsetX;
    uv.y = event.offsetY;
  } else {
    // firefox
    uv.x = event.layerX;
    uv.y = event.layerY;
  }
  return uv;
};
